import carrot from '../../img/icon-carrot-small.png'
import { withComponentLabel } from '../../utils/debug'
  
const Footer = () => {
  return (
    <>
      <nav className='h-20 py-5 bg-orange-600 merriweather'>
        <div className='flex items-center'>
          <div to='/' className='flex mx-auto h-9'>
            <img className='mx-2' src={carrot}></img>
          </div>
        </div>
      </nav>
    </>
  )
}

export default withComponentLabel(Footer, 'Footer')
